import { createSlice } from "@reduxjs/toolkit";
import {
  createTemplateThunk,
  getAllTemplatesThunk,
  getTemplateByIdThunk,
  updateTemplateByIdThunk,
  deleteTemplateByIdThunk,
  clearTemplateError,
} from "../../thunks/jewelleryPlan/planTemplateThunks";

const initialState = {
  templates: [],
  selectedTemplate: null,
  loading: false,
  error: null,
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    clearSelectedTemplate: (state) => {
      state.selectedTemplate = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create Template
      .addCase(createTemplateThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTemplateThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.templates.push(action.payload.data);
      })
      .addCase(createTemplateThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Templates
      .addCase(getAllTemplatesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTemplatesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload.data;
      })
      .addCase(getAllTemplatesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Template By ID
      .addCase(getTemplateByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTemplateByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTemplate = action.payload.data;
      })
      .addCase(getTemplateByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Template
      .addCase(updateTemplateByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTemplateByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.templates.findIndex(
          (template) => template._id === action.payload.data._id
        );
        if (index !== -1) {
          state.templates[index] = action.payload.data;
        }
        if (state.selectedTemplate?._id === action.payload.data._id) {
          state.selectedTemplate = action.payload.data;
        }
      })
      .addCase(updateTemplateByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Template
      .addCase(deleteTemplateByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTemplateByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = state.templates.filter(
          (template) => template._id !== action.meta.arg
        );
      })
      .addCase(deleteTemplateByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Clear Error
      .addCase(clearTemplateError, (state) => {
        state.error = null;
      });
  },
});

export const { clearSelectedTemplate } = templateSlice.actions;
export default templateSlice.reducer;
